import { render, staticRenderFns } from "./VehicleInsurance.vue?vue&type=template&id=4b58da0f&scoped=true&"
import script from "./VehicleInsurance.vue?vue&type=script&lang=js&"
export * from "./VehicleInsurance.vue?vue&type=script&lang=js&"
import style0 from "./VehicleInsurance.vue?vue&type=style&index=0&id=4b58da0f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b58da0f",
  null
  
)

export default component.exports